import { getRangeMinMax } from '../reducers/utils/range/get-range-min-max.ts';
import { type SelectionState } from '../state/types.ts';

import { mergeRowSegments } from './merge-row-segments.ts';

/**
 * Number of distinct row indices covered in row mode (Σ segment length after merge).
 * Returns 0 when mode is not `row`. Matches `getFlattenedSelection()` row segments for coverage.
 */
export function sumSelectedRowSpan(state: SelectionState): number {
  if (state.mode !== 'row') {
    return 0;
  }

  const intervals = state.selections.map((range) => {
    const rowBounds = getRangeMinMax(range, 'row');

    return { minRow: rowBounds.min, maxRow: rowBounds.max };
  });

  return mergeRowSegments(intervals).reduce(
    (selectedRowCount, segment) =>
      selectedRowCount + (segment.maxRow - segment.minRow + 1),
    0
  );
}
